import React, { useRef, useState } from 'react';
import './DetailDropDown.scss';
import { Stack, Typography } from '@mui/material';
import Detail, { DetailProps } from './detail/Detail';

interface DetailDropDownProps {
  title: string;
  initiallyOpen?: boolean;
  details: Array<DetailProps>;
}

function DetailDropDown({
  title,
  initiallyOpen = false,
  details,
}: DetailDropDownProps) {
  const [isOpen, setIsOpen] = useState<boolean>(initiallyOpen);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const toggleDetails = () => {
    let s = contentRef.current;
    if (s === null) {
      return;
    }
    if (!isOpen) {
      s.style.height = `${s.scrollHeight}px`;
    } else {
      s.style.height = '0';
    }
    setIsOpen(!isOpen);
  };
  const plusMinus = isOpen ? '-' : '+';

  return (
    <div className="detail-container">
      <div onClick={toggleDetails} className="detail-title">
        <Typography variant="body2" fontWeight="bold">
          {plusMinus} {title}
        </Typography>
      </div>
      <div
        style={{ height: initiallyOpen ? 'auto' : '0' }}
        ref={contentRef}
        className="detail-content"
      >
        <Stack spacing={0}>
          {details.map((item, index) => (
            <Detail key={index} title={item.title} detail={item.detail} />
          ))}
        </Stack>
      </div>
    </div>
  );
}

export default DetailDropDown;
